<template>
  <display-control
    :data-vid="settingVar.id"
    :component="controlComponent"
    :name="name"
    :description="description"
    :show-label="true"
    :showUnits="true"
    :vars="[settingVar]"
  />
</template>

<script>
import DisplayControl from '@/components/services/service/DisplayControl';
import { mapState } from 'vuex';

export default {
  name: 'SettingItem',
  components: { DisplayControl },
  data() {
    return {
      varTypeControlComponentMappings: {
        BOOL: 'SliderSwitch',
        STRING: 'TextInput',
        TIME: 'Timer',
        INT: 'NumberInput',
        SINT: 'NumberInput',
        DINT: 'NumberInput',
        USINT: 'NumberInput',
        UINT: 'NumberInput',
        UDINT: 'NumberInput',
        REAL: 'NumberInput',
        LREAL: 'NumberInput',
        DATE: 'DateInput',
        STRUCT_WEEK_TIME_REAL_4: 'SchedulerButton',
        STRUCT_WEEK_TIME_BOOL_4: 'SchedulerButton',
      },
      varNameControlComponentMappings: {
        PRESENCE_START_EVENT: 'SelectBox',
      },
    };
  },
  props: {
    settingVar: {
      required: true,
    },
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    controlComponent() {
      if (this.settingVar.component) {
        return this.settingVar.component;
      }
      let controlComponent = this.varNameControlComponentMappings[this.settingVar.name];
      if (!controlComponent) {
        controlComponent = this.varTypeControlComponentMappings[this.settingVar.type];
      }
      if (typeof controlComponent === 'function') {
        return controlComponent(this.settingVar);
      }
      return controlComponent;
    },
    name() {
      if (this.currentSnapshot.rev === 2) {
        return this.settingVar.title || '';
      }
      return this.settingVar.description || this.settingVar.actorsName;
    },
    description() {
      if (this.currentSnapshot.rev === 2) {
        return this.settingVar.description;
      }
      return '';
    },
  },
};
</script>

<style scoped>
</style>
